import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IconModule } from '../icon/icon.module';

import { ToastContainer } from './toast-container.component';
import { ToastService } from './toast.service';

import { OverlayModule } from '@angular/cdk/overlay';
import { ButtonModule } from '../button/button.module';

export { ToastContainer } from './toast-container.component';
export { ToastService } from './toast.service';
export { ToastRef } from './toast-ref';

@NgModule({
  declarations: [
    ToastContainer,
  ],
  exports: [
    ToastContainer,
  ],
  imports: [
    CommonModule,
    OverlayModule,
    ButtonModule,
    IconModule,
  ],
  entryComponents: [
    ToastContainer
  ],
  providers: [
    ToastService,
  ],
})
export class ToastModule { }
